import React from "react";

const DCDialLogo = (props: any) => {
  return (
    <svg
      width="66"
      height="18"
      viewBox="0 0 66 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7567 7.98827C28.2888 7.87704 28.7914 8.10962 29.1166 8.47367C29.7769 9.25232 29.905 12.4883 28.072 12.6501C25.7957 12.8624 25.6774 8.41299 27.7567 7.98827ZM29.501 7.04782C29.3728 6.8658 28.8111 6.24895 27.8848 6.10737C27.1359 5.98603 26.1406 6.21861 25.5986 6.60288C22.4845 8.80737 23.6868 15.6332 27.9439 14.4602C28.7914 14.2276 29.4123 13.4793 29.4812 13.368L29.501 14.3388L31.8759 14.3489V2.40625H29.501V7.04782Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.7994 10.4955C59.1345 12.1337 57.6563 13.5191 56.6019 12.5382C56.1092 12.073 56.2274 11.2337 56.7891 10.9C57.065 10.7382 58.4053 10.5157 58.7994 10.4955ZM54.897 6.72356L54.8675 8.52356C55.242 8.34154 55.2124 8.36176 55.8332 8.08873C56.188 7.93704 56.6216 7.8157 57.0453 7.77525C58.0603 7.69435 58.8487 7.91682 58.829 9.02918C58.1589 9.38311 56.4344 9.27188 55.5474 9.70671C52.4925 11.2033 54.5521 15.8651 57.7154 14.2674C58.4053 13.9236 58.3855 13.6404 58.829 13.2764L58.8487 14.3281H61.0561C61.0561 13.064 61.0561 11.8101 61.0561 10.546C61.0561 9.24154 61.1645 8.22019 60.5437 7.26963C59.4301 5.57075 56.4935 5.97525 54.897 6.72356Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.632 14.0337L39.6418 12.1427C39.2575 12.173 38.3312 12.9921 37.0895 12.5269C34.4584 11.5561 35.8281 6.67188 39.0998 8.23929C39.2969 8.32019 39.4053 8.38086 39.6418 8.47187V6.46963C38.3706 5.83255 36.3997 5.94379 35.1679 6.70221C32.8422 8.13817 32.4776 12.3247 35.1482 14.0033C36.2322 14.691 38.5381 14.8022 39.632 14.0337Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.7998 14.3163H65.1649L65.155 2.41406H62.7998V14.3163Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.4426 14.3137H52.8471V6.30469H50.4426C50.4426 7.4575 50.4426 13.717 50.4426 14.3137Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62482 0.0078125L17.6365 0.715678L13.7834 4.72017H5.45636L1.6131 0.715678L9.62482 0.0078125Z"
        fill="#FDD12F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6247 17.9656L1.61298 17.2779L5.45624 13.2734H13.7833L17.6364 17.2779L9.6247 17.9656Z"
        fill="#39C84F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.864136 9.00077L1.61308 0.71875L5.45634 4.72324V13.2783L1.61308 17.2828L0.864136 9.00077Z"
        fill="var(--color-blue2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3656 9.00077L17.6363 0.71875L13.7832 4.72324V13.2783L17.6363 17.2828L18.3656 9.00077Z"
        fill="#C51F25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.6347 4.94077C52.3048 4.94077 52.8468 4.38459 52.8468 3.69695C52.8468 3.0093 52.3048 2.45312 51.6347 2.45312C50.9646 2.45312 50.4226 3.0093 50.4226 3.69695C50.4226 4.38459 50.9646 4.94077 51.6347 4.94077Z"
        fill="#848182"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5202 7.98827C45.0524 7.87704 45.5549 8.10962 45.8801 8.47367C46.5404 9.25232 46.6685 12.4883 44.8356 12.6501C42.5493 12.8624 42.4311 8.41299 44.5202 7.98827ZM46.2546 7.04782C46.1265 6.8658 45.5648 6.24895 44.6385 6.10737C43.8895 5.98603 42.8942 6.21861 42.3522 6.60288C39.2382 8.80737 40.4405 15.6332 44.6976 14.4602C45.5451 14.2276 46.1659 13.4793 46.2448 13.368L46.2645 14.3388L48.6394 14.3489V2.40625H46.2546V7.04782Z"
        fill="#848182"
      />
    </svg>
  );
};

export default DCDialLogo;
